"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiDivider = void 0;
exports.MuiDivider = {
    defaultProps: {
        "aria-hidden": "true",
    },
};
//# sourceMappingURL=divider.js.map